/**
 * Canonical v5 accent palette — 7 families × tones.
 *
 * ⚠️ Source of truth for the *build-time* path is still
 * src/styles/accent.css (the :root[data-accent="…"] map). This array
 * mirrors those exact hexes so the admin Appearance picker can offer the
 * vetted palette as swatches. If you change a preset, change BOTH here
 * and in accent.css (they intentionally duplicate — accent.css has no JS,
 * this list is for the runtime picker).
 *
 * Deep Burgundy's "Deeper" tone was retired in brand v4 (read too close
 * to carbon page text) — only Base + Lifted ship, matching accent.css.
 */

export interface AccentPreset {
  /** data-accent name in accent.css */
  name: string;
  family: string;
  tone: 'Deeper' | 'Base' | 'Lifted';
  hex: string;
}

export const ACCENT_PRESETS: AccentPreset[] = [
  { name: 'burgundy-base', family: 'Burgundy', tone: 'Base', hex: '#3F1D17' },
  { name: 'burgundy-lifted', family: 'Burgundy', tone: 'Lifted', hex: '#6B342B' },

  { name: 'terracotta-deeper', family: 'Terracotta', tone: 'Deeper', hex: '#8F4F33' },
  { name: 'terracotta-base', family: 'Terracotta', tone: 'Base', hex: '#C97D58' },
  { name: 'terracotta-lifted', family: 'Terracotta', tone: 'Lifted', hex: '#E2A98A' },

  { name: 'teal-deeper', family: 'Teal', tone: 'Deeper', hex: '#355861' },
  { name: 'teal-base', family: 'Teal', tone: 'Base', hex: '#4F7E8C' },
  { name: 'teal-lifted', family: 'Teal', tone: 'Lifted', hex: '#7BA5B2' },

  { name: 'primrose-deeper', family: 'Primrose', tone: 'Deeper', hex: '#C9A521' },
  { name: 'primrose-base', family: 'Primrose', tone: 'Base', hex: '#F4D03F' },
  { name: 'primrose-lifted', family: 'Primrose', tone: 'Lifted', hex: '#F8DE73' },

  { name: 'pink-deeper', family: 'Pink', tone: 'Deeper', hex: '#D87689' },
  { name: 'pink-base', family: 'Pink', tone: 'Base', hex: '#F4A7B9' },
  { name: 'pink-lifted', family: 'Pink', tone: 'Lifted', hex: '#FAC8D2' },

  { name: 'warm-grey-deeper', family: 'Warm grey', tone: 'Deeper', hex: '#423D37' },
  { name: 'warm-grey-base', family: 'Warm grey', tone: 'Base', hex: '#8A8276' },
  { name: 'warm-grey-lifted', family: 'Warm grey', tone: 'Lifted', hex: '#C8BFAF' },

  { name: 'cool-grey-deeper', family: 'Cool grey', tone: 'Deeper', hex: '#353B43' },
  { name: 'cool-grey-base', family: 'Cool grey', tone: 'Base', hex: '#7B838E' },
  { name: 'cool-grey-lifted', family: 'Cool grey', tone: 'Lifted', hex: '#BFC6CE' },
];
